import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ProfileComponent } from "./profile/profile.component";
import { HomeComponent } from "./home/home.component";
import { MsalGuard } from "@azure/msal-angular";
import { StudentDetailComponent } from "./student-detail/student-detail.component";

const routes: Routes = [
	{
		path: "Home",
		component: HomeComponent,
	},{
		// Needed for hash routing
		path: "code",
		component: HomeComponent,
	},
  {
		// Needed for Error routing
		path: "StudentDetail",
		component: StudentDetailComponent,
	},
	{
		// Needed for Error routing
		path: "error",
		component: HomeComponent,
	},
  {
		// Needed for Error routing
		path: "",
		component: HomeComponent,
	},
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: true
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
